import type { RouteObject } from 'react-router';
import { READABLE_OFFLINE } from '../../core/pwa/works-offline';

/**
 * One route today. It is a child route file rather than a `lazy` entry in `app.routes.tsx` so the
 * screen's later surfaces — an edit view, an adopt view — arrive as siblings inside this chunk
 * rather than as further entries in the application's route table.
 *
 * 036 (issue 221, FR-021): the recurring list is readable offline.
 */
export const routes: RouteObject[] = [
  {
    index: true,
    handle: { [READABLE_OFFLINE]: true },
    lazy: async () => ({ Component: (await import('./recurring-page')).default }),
  },
];
